.mention {
  padding: 1rem;
  margin: 0;
  margin-left: -1rem;

  &:nth-child(even) {
    background-color: var(--gray-50);
  }
}

.info {
  color: var(--gray-600);
}
